import { Button, Stack, Text } from '@mantine/core'

export const PAGE_LOAD_RECOVERY_MESSAGE =
  'Unable to load this page. The application may have been updated or your connection may have been interrupted. Reload the page to try again.'

type Props = {
  reload?: () => void
}

const reloadCurrentPage = () => window.location.reload()

const PageLoadRecovery = ({ reload = reloadCurrentPage }: Props) => {
  const handleReload = () => {
    try {
      reload()
    } catch {
      // Keep the screen available so the user can retry.
    }
  }

  return (
    <Stack
      align="center"
      data-testid="page-load-recovery-card"
      gap="md"
      p="xl"
      role="alert"
    >
      <Text data-testid="page-load-recovery-message-label" ta="center">
        {PAGE_LOAD_RECOVERY_MESSAGE}
      </Text>
      <Button
        data-testid="page-load-recovery-reload-button"
        onClick={handleReload}
      >
        Reload page
      </Button>
    </Stack>
  )
}

export default PageLoadRecovery
